import styled from 'styled-components';
import { ApModal, colors } from '@alixpartners/ui-components';

export const StyledModal = styled(ApModal)`
	.ap-modal-lightbox {
		background-color: rgba(50, 50, 50, 0.3);
	}
	.ap-modal-content {
		max-width: 600px;
		border-radius: 1px;
		box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.25);
	}

	.ap-modal-header {
		border-bottom: none;
		padding: 24px 32px 8px 32px;
		h4 {
			font-size: 23px;
			line-height: 31px;
			letter-spacing: 0.3px;
			color: ${colors.grey8};
			font-weight: 500;
		}
		.ap-button-icon {
			position: relative;
			top: -5px;
			right: -14px;
		}
	}

	.ap-modal-footer {
		padding: 13px 32px 12px 32px;
		display: flex;

		.ap-button-secondary {
			margin-left: auto;
			margin-right: 24px;
		}
	}

	.ap-modal-body {
		padding: 16px 24px 32px 32px;
		line-height: 24px;
	}
`;
